module.exports = __webpack_public_path__ + "img/TvDip-logoFooter.d63bcf.png";